import React from 'react';
import classNames from 'classnames';

import { Box, Container, Text } from 'components';

const Alert = props => {
  const { children, type, message, rounded, action } = props;

  const classes = classNames({
    [`alert-${type}`]: type,
    rounded: rounded,
  });

  return (
    <Box className={classes} py="3">
      <Container flex alignItems="center">
        <Box flex>
          <div className="alert-icon" />
          {children || <Text mb="0">{message}</Text>}
        </Box>
        {action && <Box ml="auto">{action}</Box>}
      </Container>
    </Box>
  );
};

Alert.defaultProps = {
  type: 'warning',
  show: true,
};

export default Alert;
